import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconAspectRatio11: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"aspect-ratio-1-1, square"} maskId="square-filled-radius-0-stroke-1-IconAspectRatio11"><path d="M3 3V21H21V3H3Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconAspectRatio11;
